export const MAX_STEPS_PER_FRAME = 400
/** How many dt steps to run for a wall-clock frame at a given speed; fractional steps carry over; long gaps are capped. */
export function stepsFor(elapsedMs, speed, carry, dt = 0.1) {
  const want = carry + (elapsedMs / 1000) * speed / dt
  if (want > MAX_STEPS_PER_FRAME) return { steps: MAX_STEPS_PER_FRAME, carry: 0 }
  const steps = Math.floor(want)
  return { steps, carry: want - steps }
}
